import { instanceOfErrorListResponse, type ErrorListResponse } from '@genial/services';

import { useToastCreator } from '../../../hooks/useToastCreator';

export const useErrorToast = () => {
  const { showToastFromError } = useToastCreator('toast-error-redeem-query');

  const handleErrorToast = (error?: Error) => {
    if (error && instanceOfErrorListResponse(error)) {
      (error as unknown as ErrorListResponse).errors?.forEach((errorItem) =>
        showToastFromError(errorItem)
      );
    }
  };

  return {
    handleErrorToast,
  };
};
